import { render, staticRenderFns } from "./GiveTest.vue?vue&type=template&id=0636f662&scoped=true&"
import script from "./GiveTest.vue?vue&type=script&lang=js&"
export * from "./GiveTest.vue?vue&type=script&lang=js&"
import style0 from "./GiveTest.vue?vue&type=style&index=0&id=0636f662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0636f662",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VBtn,VCol,VContainer,VFooter,VIcon,VMain})
